import queryString from 'query-string';
import crud from './crud';
import settings from '../../config/settings';
import {
  API_LOADED_LOCATIONS,
  SET_FILTER,
  API_CLEAR,
} from '../types';

const retrieveLocations = function retrieveLocations(loadAll = false, page, noLoader) {
  return function retrieveLocationsFunction(dispatch, getState) {
    const {
      session: {
        affiliateId,
      },
      filter: {
        locations: {
          filterKey,
          sortKey,
        },
      },
    } = getState();

    let params = [];
    if (filterKey !== 'all' && filterKey.indexOf(':') !== -1) {
      const [status, filter] = filterKey.split(':');
      params.push(`${status}=${filter}`);
    }
    if (sortKey) {
      params.push(`order=${sortKey}`);
    }
    params = params.join('&');

    return dispatch(crud.apiRead({
      type: 'gemsLocations',
      urlParams: {
        affiliateId,
        page,
        params,
      },
      noLoader,
    }))
    .then(() => {
      dispatch({
        type: API_LOADED_LOCATIONS,
        payload: {
          type: 'location',
        },
      });
    });
  };
};

const retrieveMoreLocations = function retrieveMoreLocations() {
  return function retrieveMoreLocationsFunction(dispatch, getState) {
    const {
      api: {
        nextAction: {
          locations,
        },
      },
    } = getState();

    if (locations) {
      const loadAll = false;
      return dispatch(retrieveLocations(loadAll, locations));
    }

    return null;
  };
};

const retrieveLocationTypes = function retrieveLocationTypes(page) {
  return function retrieveLocationTypesFunction(dispatch, getState) {
    const state = getState();
    const { session: { affiliateId } } = state;

    return dispatch(crud.apiRead({
      type: 'locationTypes',
      urlParams: {
        affiliateId,
        page,
      },
    }))
    .then((results) => {
      if (results.links.next !== null && settings.enable_all_data_fetch === true) {
        const params = queryString.parse(results.links.next.split('?')[1]);
        return dispatch(retrieveLocationTypes(params.page || null));
      }

      return null;
    });
  };
};

const clearLocations = function clearLocations() {
  return {
    type: API_CLEAR,
    payload: {
      resource: {
        type: 'gemsLocations',
      },
    },
  };
};

const filterLocations = function filterLocations(filterKey, sortKey) {
  return function filterLocationsFunction(dispatch) {
    dispatch({
      type: SET_FILTER,
      payload: {
        locations: {
          filterKey,
          sortKey,
        },
      },
    });
    dispatch(clearLocations());
    const loadAll = false;
    return dispatch(retrieveLocations(loadAll));
  };
};

const retrieveLocationById = function retrieveLocationById(id) {
  return function retrieveRequestByIDFunction(dispatch, getState) {
    const state = getState();
    const { session: { affiliateId } } = state;

    return dispatch(crud.apiRead({
      type: 'location',
      urlParams: {
        affiliateId,
        id,
      },
    }));
  };
};

const updateLocation = function updateLocation(roomId, data) {
  return function updateLocationFunction(dispatch, getState) {
    const state = getState();
    const { session: { affiliateId } } = state;

    return dispatch(crud.apiUpdate({
      type: 'location',
      urlParams: {
        affiliateId,
        id: roomId,
      },
      data,
    }));
  };
};

export default {
  retrieveLocationTypes,
  retrieveLocations,
  retrieveLocationById,
  retrieveMoreLocations,
  filterLocations,
  updateLocation,
  clearLocations,
};



// WEBPACK FOOTER //
// ./src/state/actions/locations.js